(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["WISHLIST_HERO_BKP_header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('hero-slideshow')) return;

    const MOBILE_QUERY = '(max-width: 749px)';
    const PLAY_TIMEOUT = 8000;
    const EXTERNAL_ORIGINS = {
      youtube: 'https://www.youtube-nocookie.com',
      vimeo: 'https://player.vimeo.com'
    };

    class NativePlayer {
      constructor(video, events) {
        this.el = video;
        this.loop = video.loop;
        this.startsMuted = false;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };

        video.addEventListener(
          'playing',
          () => {
            video.classList.add('is-ready');
            events.playing(this);
          },
          options
        );
        video.addEventListener('pause', () => events.paused(this), options);
        video.addEventListener('ended', () => events.ended(this), options);
      }

      get muted() {
        return this.el.muted;
      }

      get playing() {
        return !this.el.paused && !this.el.ended && this.el.readyState > 2;
      }

      setMuted(muted) {
        this.el.muted = muted;
      }

      play() {
        const result = this.el.play();
        return result && typeof result.then === 'function' ? result : Promise.resolve();
      }

      pause() {
        this.el.pause();
      }

      reset() {
        this.el.pause();
        if (this.el.readyState > 0) this.el.currentTime = 0;
      }

      preload() {
  if (this.el.preload !== 'auto') this.el.preload = 'auto';
}

      destroy() {
        this.controller.abort();
        this.el.pause();
      }
    }

    class ExternalPlayer {
      constructor(container, loop, events) {
        this.el = container;
        this.provider = container.dataset.provider === 'vimeo' ? 'vimeo' : 'youtube';
        this.videoId = container.dataset.videoId;
        this.origin = EXTERNAL_ORIGINS[this.provider];
        this.loop = loop;
        this.events = events;
        this.startsMuted = true;
        this.muted = true;
        this.ready = false;
        this.state = null;
        this.queue = [];
        this.onMessage = this.onMessage.bind(this);
      }

      get playing() {
        return this.state === 'playing';
      }

      get isYoutube() {
        return this.provider === 'youtube';
      }

      buildSrc() {
        const id = encodeURIComponent(this.videoId);

        if (this.isYoutube) {
          const params = new URLSearchParams({
            enablejsapi: '1',
            origin: window.location.origin,
            autoplay: '1',
            mute: this.muted ? '1' : '0',
            controls: '0',
            playsinline: '1',
            rel: '0',
            modestbranding: '1',
            iv_load_policy: '3',
            disablekb: '1',
            fs: '0'
          });
          if (this.loop) {
            params.set('loop', '1');
            params.set('playlist', this.videoId);
          }
          return `${this.origin}/embed/${id}?${params}`;
        }

        const params = new URLSearchParams({
          autoplay: '1',
          muted: this.muted ? '1' : '0',
          loop: this.loop ? '1' : '0',
          controls: '0',
          playsinline: '1',
          autopause: '0',
          dnt: '1',
          title: '0',
          byline: '0',
          portrait: '0'
        });
        return `${this.origin}/video/${id}?${params}`;
      }

      load() {
        const iframe = document.createElement('iframe');
        iframe.src = this.buildSrc();
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
        iframe.title = this.el.dataset.title || 'Video';
        iframe.tabIndex = -1;
        window.addEventListener('message', this.onMessage);

        if (this.isYoutube) {
          iframe.addEventListener('load', () => {
            let attempts = 0;
            this.handshake = setInterval(() => {
              if (this.ready || attempts > 40) {
                clearInterval(this.handshake);
                return;
              }
              attempts += 1;
              this.post({ event: 'listening', id: this.videoId, channel: 'widget' });
            }, 250);
          });
        }

        this.el.appendChild(iframe);
        this.iframe = iframe;
      }

      post(message) {
        if (!this.iframe || !this.iframe.contentWindow) return;
        this.iframe.contentWindow.postMessage(JSON.stringify(message), this.origin);
      }

      command(name, value) {
        const message = this.isYoutube
          ? {
              event: 'command',
              func: name,
              args: value === undefined ? [] : [].concat(value),
              id: this.videoId,
              channel: 'widget'
            }
          : { method: name, value };

        if (this.ready) this.post(message);
        else this.queue.push(message);
      }

      markReady() {
        this.ready = true;
        if (this.isYoutube) {
          this.post({
            event: 'command',
            func: 'addEventListener',
            args: ['onStateChange'],
            id: this.videoId,
            channel: 'widget'
          });
        } else {
          ['playing', 'pause', 'ended'].forEach((name) => {
            this.post({ method: 'addEventListener', value: name });
          });
        }
        this.queue.splice(0).forEach((message) => this.post(message));
      }

      readState(data) {
        if (!this.isYoutube) {
          return { playing: 'playing', pause: 'paused', ended: 'ended' }[data.event];
        }
        let code;
        if (data.event === 'onStateChange') code = data.info;
        else if (data.event === 'infoDelivery' && data.info) code = data.info.playerState;
        return { 0: 'ended', 1: 'playing', 2: 'paused' }[code];
      }

      onMessage(event) {
        if (!this.iframe || event.source !== this.iframe.contentWindow) return;

        let data = event.data;
        if (typeof data === 'string') {
          try {
            data = JSON.parse(data);
          } catch (error) {
            return;
          }
        }
        if (!data || typeof data !== 'object') return;

        if (!this.ready) {
          const readyEvents = this.isYoutube ? ['onReady', 'initialDelivery', 'infoDelivery'] : ['ready'];
          if (readyEvents.includes(data.event)) this.markReady();
        }

        const state = this.readState(data);
        if (!state || state === this.state) return;
        this.state = state;

        if (state === 'playing') {
          this.el.classList.add('is-ready');
          this.events.playing(this);
        } else if (state === 'paused') {
          this.el.classList.remove('is-ready');
          this.events.paused(this);
        } else if (!this.loop) {
          this.events.ended(this);
        }
      }

      setMuted(muted) {
        this.muted = muted;
        if (!this.iframe) return;
        if (this.isYoutube) this.command(muted ? 'mute' : 'unMute');
        else this.command('setMuted', muted);
      }

      play() {
        if (!this.iframe) this.load();
        else this.command(this.isYoutube ? 'playVideo' : 'play');
        return Promise.resolve();
      }

      pause() {
        if (this.iframe) this.command(this.isYoutube ? 'pauseVideo' : 'pause');
      }

      reset() {
        if (!this.iframe) return;
        this.pause();
        if (this.isYoutube) this.command('seekTo', [0, true]);
        else this.command('setCurrentTime', 0);
        this.el.classList.remove('is-ready');
      }

      preload() {}

      destroy() {
        clearInterval(this.handshake);
        window.removeEventListener('message', this.onMessage);
        if (this.iframe) this.iframe.remove();
        this.iframe = null;
        this.ready = false;
        this.state = null;
        this.queue = [];
        this.el.classList.remove('is-ready');
      }
    }

    class HeroSlideshow extends HTMLElement {
      connectedCallback() {
        this.active = true;
        let attempts = 0;

        const check = () => {
          if (!this.active || this.initialized) return;
          const parsed = document.readyState !== 'loading';
          const single = this.querySelectorAll('[data-slide]').length < 2;
          if (parsed && (single || window.Flickity || attempts > 100)) {
            this.init();
            return;
          }
          attempts += 1;
          setTimeout(check, 100);
        };

        check();
      }

      disconnectedCallback() {
        this.active = false;
        if (!this.initialized) return;
        this.initialized = false;
        clearTimeout(this.watchdog);
        if (this.listeners) this.listeners.abort();
        if (this.observer) this.observer.disconnect();
        if (this.players) {
          this.players.forEach((list) => list.forEach((player) => player.destroy()));
        }
        if (this.flickity) {
          this.flickity.destroy();
          this.flickity = null;
        }
        this.classList.remove('is-initialized');
      }

      init() {
        this.initialized = true;
        this.slider = this.querySelector('[data-slider]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        if (!this.slider || !this.slides.length) return;

        const connection = navigator.connection || {};
        this.controls = this.querySelector('[data-controls]');
        this.playButton = this.querySelector('[data-toggle-play]');
        this.muteButton = this.querySelector('[data-toggle-mute]');
        this.mobileQuery = window.matchMedia(MOBILE_QUERY);
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.blockVideoAutoplay = this.reducedMotion || connection.saveData === true;
        this.rotationDelay = this.reducedMotion ? 0 : Number(this.dataset.autoplay) || 0;
        this.players = new Map();
        this.currentIndex = -1;
        this.inView = true;
        this.wantsPlay = false;
        this.userMuted = null;
        this.held = false;
        this.editorHold = false;
        this.playerEvents = {
          playing: (player) => this.onPlaying(player),
          paused: (player) => this.onPaused(player),
          ended: (player) => this.onEnded(player)
        };

        if (this.slides.length > 1 && window.Flickity) {
          this.flickity = new window.Flickity(this.slider, {
            cellSelector: '[data-slide]',
            cellAlign: 'left',
            wrapAround: true,
            adaptiveHeight: this.dataset.heightMode === 'adaptive',
            prevNextButtons: this.hasAttribute('data-arrows'),
            pageDots: this.hasAttribute('data-dots'),
            autoPlay: this.rotationDelay || false,
            pauseAutoPlayOnHover: this.hasAttribute('data-pause-on-hover'),
            rightToLeft: document.documentElement.dir === 'rtl',
            dragThreshold: 8
          });
          this.flickity.on('select', () => this.onSelect());
          this.flickity.on('settle', () => this.onSettle());
          this.flickity.on('resize', () => {
            this.sizedWidth = this.slider.offsetWidth;
          });
          this.sizedWidth = this.slider.offsetWidth;
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              if (this.flickity) this.classList.add('is-initialized');
            });
          });
        }

        this.listeners = new AbortController();
        const options = { signal: this.listeners.signal };

        if (this.playButton) this.playButton.addEventListener('click', () => this.togglePlay(), options);
        if (this.muteButton) this.muteButton.addEventListener('click', () => this.toggleMute(), options);
        this.mobileQuery.addEventListener('change', () => this.onBreakpoint(), options);
        document.addEventListener('visibilitychange', () => this.sync(), options);
        this.addEventListener('shopify:block:select', (event) => this.onBlockSelect(event), options);
        this.addEventListener('shopify:block:deselect', () => this.onBlockDeselect(), options);

        this.observer = new IntersectionObserver(
          (entries) => {
            this.inView = entries[entries.length - 1].isIntersecting;
            this.rotation(this.inView ? 'unpausePlayer' : 'pausePlayer');
            this.sync();
          },
          { threshold: 0.25 }
        );
        this.observer.observe(this);

        this.onSelect();
      }

      get visible() {
        return this.inView && !document.hidden;
      }

      get currentSlide() {
        return this.slides[this.currentIndex];
      }

      rotation(method) {
        if (this.flickity && typeof this.flickity[method] === 'function') this.flickity[method]();
      }

      getPlayers(slide) {
        if (!slide || !slide.hasAttribute('data-video-slide')) return [];

        if (!this.players.has(slide)) {
          const loop = slide.hasAttribute('data-video-loop');
          const list = Array.from(slide.querySelectorAll('[data-video]')).map(
            (video) => new NativePlayer(video, this.playerEvents)
          );
          const external = slide.querySelector('[data-external]');
          if (external) list.push(new ExternalPlayer(external, loop, this.playerEvents));
          this.players.set(slide, list);
        }

        return this.players.get(slide);
      }

      getActivePlayer(slide = this.currentSlide) {
        const list = this.getPlayers(slide);
        if (list.length < 2) return list[0] || null;
        const variant = this.mobileQuery.matches ? 'mobile' : 'desktop';
        return list.find((player) => player.el.dataset.video === variant) || list[0];
      }

      preferredMuted(slide, player) {
        if (this.userMuted !== null) return this.userMuted;
        return player.startsMuted || slide.hasAttribute('data-video-muted');
      }

      onSelect() {
        const index = this.flickity ? this.flickity.selectedIndex : 0;
        if (index === this.currentIndex) return;

        const previous = this.currentSlide;
        this.currentIndex = index;
        clearTimeout(this.watchdog);
        this.getPlayers(previous).forEach((player) => player.pause());
        this.slides.forEach((slide, position) => {
          slide.inert = position !== index;
        });
        this.warmUp(index);
        this.startSlide();
      }

      onSettle() {
        if (this.flickity && this.slider.offsetWidth !== this.sizedWidth) this.flickity.resize();
        this.players.forEach((list, slide) => {
          if (slide !== this.currentSlide) list.forEach((player) => player.reset());
        });
      }

      warmUp(index) {
        const count = this.slides.length;
        const next = (index + 1) % count;
        const previous = (index - 1 + count) % count;

        [index, next, previous].forEach((position) => {
          this.slides[position].querySelectorAll('img[loading="lazy"]').forEach((image) => {
            image.loading = 'eager';
          });
        });

        if (next !== index) {
          const player = this.getActivePlayer(this.slides[next]);
          if (player) player.preload();
        }
      }

      startSlide() {
        const slide = this.currentSlide;
        const player = this.getActivePlayer(slide);

        this.wantsPlay = Boolean(player) && slide.hasAttribute('data-video-autoplay') && !this.blockVideoAutoplay;
        if (this.controls) this.controls.hidden = !(player && slide.hasAttribute('data-video-controls'));
       if (player) player.preload();
        if (!this.wantsPlay) this.releaseRotation();
        this.sync();
      }

      sync() {
        const player = this.getActivePlayer();

        if (player) {
          if (this.wantsPlay && this.visible) {
            if (!player.playing) this.play(player);
          } else {
            clearTimeout(this.watchdog);
            player.pause();
          }
        }

        this.updateControls();
      }

      async play(player) {
        if (!player.loop) this.holdRotation();

        clearTimeout(this.watchdog);
        this.watchdog = setTimeout(() => {
          if (player === this.getActivePlayer() && !player.playing) this.onBlocked(player);
        }, PLAY_TIMEOUT);

        try {
          try {
            await player.play();
          } catch (error) {
            if ((error && error.name === 'AbortError') || player.muted) throw error;
            player.setMuted(true);
            this.updateControls();
            await player.play();
          }
        } catch (error) {
          if (!error || error.name !== 'AbortError') this.onBlocked(player);
        }
      }

      onBlocked(player) {
        if (player !== this.getActivePlayer()) return;
        clearTimeout(this.watchdog);
        this.wantsPlay = false;
        player.pause();
        this.releaseRotation();
        this.updateControls();
      }

      onPlaying(player) {
        if (player !== this.getActivePlayer()) {
          player.pause();
          return;
        }
        clearTimeout(this.watchdog);
        this.updateControls();
      }

      onPaused(player) {
        if (player === this.getActivePlayer()) this.updateControls();
      }

      onEnded(player) {
        if (player !== this.getActivePlayer()) return;
        this.wantsPlay = false;
        this.updateControls();

        const advance = this.held && !this.editorHold;
        this.releaseRotation();
        if (advance) this.rotation('next');
      }

      holdRotation() {
        if (!this.flickity || !this.rotationDelay) return;
        this.held = true;
        this.rotation('stopPlayer');
      }

      releaseRotation() {
        if (!this.held) return;
        this.held = false;
        if (this.rotationDelay && !this.editorHold) this.rotation('playPlayer');
      }

      togglePlay() {
        if (!this.getActivePlayer()) return;
        this.wantsPlay = !this.wantsPlay;
        this.sync();
      }

      toggleMute() {
        const player = this.getActivePlayer();
        if (!player) return;
        this.userMuted = !player.muted;
        player.setMuted(this.userMuted);
        this.updateControls();
      }

      updateControls() {
        const player = this.getActivePlayer();
        const paused = !this.wantsPlay;
        const muted = player ? player.muted : true;

        this.classList.toggle('is-video-paused', paused);
        this.classList.toggle('is-video-unmuted', !muted);

        if (this.playButton) {
          const label = paused ? this.playButton.dataset.labelPlay : this.playButton.dataset.labelPause;
          this.playButton.setAttribute('aria-label', label);
        }
        if (this.muteButton) {
          const label = muted ? this.muteButton.dataset.labelUnmute : this.muteButton.dataset.labelMute;
          this.muteButton.setAttribute('aria-label', label);
        }
      }

      onBreakpoint() {
        const slide = this.currentSlide;
        if (!slide) return;

        const active = this.getActivePlayer(slide);
        this.getPlayers(slide).forEach((player) => {
          if (player !== active) player.reset();
        });
        if (active) active.setMuted(this.preferredMuted(slide, active));
        this.sync();
      }

      onBlockSelect(event) {
        const index = this.slides.indexOf(event.target);
        if (index < 0 || !this.flickity) return;
        this.editorHold = true;
        this.rotation('stopPlayer');
        this.flickity.select(index, true, true);
      }

      onBlockDeselect() {
        this.editorHold = false;
        if (this.rotationDelay && !this.held) this.rotation('playPlayer');
      }
    }

    customElements.define('hero-slideshow', HeroSlideshow);
  })();

  } catch(e) { console.error(e); }
})();
})();
